/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

function ShowSelectedImages() {
  if(document.querySelectorAll('variant-swatches').length > 0){
    var value = document.querySelector('variant-swatches .product-form__swatch__sub-title').innerText.trim().toLowerCase();
    var thumbnails = document.querySelectorAll('.media-gallery__thumbs .thumbnail-list__item');
    var selected = false;
    
    for (let i = 0; i < thumbnails.length; i++) {
      var thumbnail = thumbnails[i];
      var thumbnail_img_alt = thumbnail.querySelector("img").attributes.alt.value.toLowerCase().replaceAll('-',' ').replaceAll('/',' ');
      
      if(thumbnail_img_alt == value){
        thumbnail.style.display = "block";
        if(!selected){
          $(".media-gallery__slider").slick('goTo', i);
          selected = true;
        }
      }else{
        thumbnail.style.display = "none"
      }
    }

  }

  if(document.querySelectorAll('variant-swatches').length > 0){
    var value = document.querySelector('variant-swatches .product-form__swatch__sub-title').innerText.trim().toLowerCase();
    var gallery_images = document.querySelectorAll('.media-gallery__slider .media-gallery__wrapper');

    for (let i = 0; i < gallery_images.length; i++) {
      var gallery_image = gallery_images[i].parentElement.parentElement;
      var gallery_image_img_alt = gallery_image.querySelector("img").attributes.alt.value.toLowerCase().replaceAll('-',' ').replaceAll('/',' ');
      
      gallery_image.style.visibility = "inherit";
    }
    
    for (let i = 0; i < gallery_images.length; i++) {
      var gallery_image = gallery_images[i].parentElement.parentElement;
      var gallery_image_img_alt = gallery_image.querySelector("img").attributes.alt.value.toLowerCase().replaceAll('-',' ').replaceAll('/',' ');

      if(gallery_image_img_alt == value){
        gallery_image.style.visibility = "inherit";
      }else{
        gallery_image.style.visibility = "hidden"
      }
    }
  }

}

$(document).ready(function() {
  ShowSelectedImages();
});

$(document).on("click","variant-swatches .product-form__swatch__label",function() {
  setTimeout(function() {
    ShowSelectedImages();
    // if($(window).width() < 960){
    //   $('html, body').animate({scrollTop : 100}, 800);
    // }
  }, 100);
});

// $(".media-gallery__slider").on("beforeChange", function (event, slick, currentSlide, nextSlide){
//   if(document.querySelectorAll('variant-swatches').length > 0){
//     var value = document.querySelector('variant-swatches .product-form__swatch__sub-title').innerText.trim().toLowerCase();
//     var gallery__sliders = document.querySelectorAll('.media-gallery__slider .media-gallery__wrapper');
//     var filter_value = gallery__sliders[nextSlide].dataset.filter.toLowerCase().replaceAll('-',' ').replaceAll('/',' ');

    
//     if(filter_value == value){
      
//     }else{
//       debugger
//       setTimeout(function() {
//         $(".media-gallery__slider").slick('goTo', currentSlide)
//       }, 500);
//     }
//   }
// });
